/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type updatePictureMutationVariables = {|
  id: string,
  recipe: string,
|};
export type updatePictureMutationResponse = {|
  +recipeMediaUpdate: ?{|
    +recipeMedia: ?{|
      +id: string,
      +file: string,
    |}
  |}
|};
export type updatePictureMutation = {|
  variables: updatePictureMutationVariables,
  response: updatePictureMutationResponse,
|};
*/


/*
mutation updatePictureMutation(
  $id: ID!
  $recipe: ID!
) {
  recipeMediaUpdate(input: {id: $id, recipe: $recipe}) {
    recipeMedia {
      id
      file
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "recipe",
    "type": "ID!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
          },
          {
            "kind": "Variable",
            "name": "recipe",
            "variableName": "recipe"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "RecipeMediaUpdatePayload",
    "kind": "LinkedField",
    "name": "recipeMediaUpdate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RecipeMediaNode",
        "kind": "LinkedField",
        "name": "recipeMedia",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "file",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updatePictureMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updatePictureMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "updatePictureMutation",
    "operationKind": "mutation",
    "text": "mutation updatePictureMutation(\n  $id: ID!\n  $recipe: ID!\n) {\n  recipeMediaUpdate(input: {id: $id, recipe: $recipe}) {\n    recipeMedia {\n      id\n      file\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '059f4dfddf16bf9a94bf5c8c20c20521';

module.exports = node;
